<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <info-modal ref="infoModal" @onUpdateProcessingPeriods="onUpdateProcessingPeriods"></info-modal>
    <check-materials-modal ref="checkMaterialsModal" @onProceed="onProceed"></check-materials-modal>
    <show-errors-modal ref="errorsModal"></show-errors-modal>
    <div style="background: #eeeeee;">
      <transition name="fade" mode="out-in" v-if="selectedProcessingProject === null">
        <search-box-processing ref="searchBoxProcessing" style="margin-top: 150px"
                               @onToggleSelectedProject="onToggleSelectedProject"></search-box-processing>
      </transition>
      <g-map-data-processing @onMapClicked="onMapClicked" @onMapLoaded="onMapLoaded"></g-map-data-processing>

      <div v-if="selectedProcessingProject" class="pb-6">
        <div>
          <div class="is-flex has-background-white title-box p-2">
            <div class="is-size-4 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedProcessingProject.project.name }}
            </div>
            <b-tooltip class="ml-1 mt-auto mb-auto mr-2" label="Refresh project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button aria-label="refresh"
                        @click="onRefreshClicked">
                <b-icon icon="refresh"></b-icon>
              </b-button>
            </b-tooltip>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        @click="closeProjectOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex is-flex-direction-column p-5" style="padding-bottom: 200px !important;">
            <div class="is-size-6 mb-3 mt-2">PROJECT TASKS</div>
            <data-processing-card :progress="progress"
                                  :progress-step-one="progressStepOne"
                                  v-for="dt in selectedProcessingProject.devices" :key="dt._id" :device-data="dt"
                                  @onProcessingClick="onProcessingClick"
                                  @onRunTasksClick="onRunTasksClick"
                                  @onAddTasksClick="onAddTasksClick" @onRunInitialValidation="onRunInitialValidation"
                                  @onShowInitialResults="onShowInitialResults" @onShowFullResults="onShowFullResults"
                                  @onRunFullProcessing="onRunFullProcessing"
                                  @onRunPedestrianProcessing="onRunPedestrianProcessing"
                                  @onResetStep="onResetStep"
                                  @onShowError="onShowErrors"
            ></data-processing-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBoxProcessing
  from "@/modules/data-processing-module/components/search-box-processing/search-box-processing.vue";
import {mapActions, mapGetters} from "vuex";
import GMapDataProcessing
  from "@/modules/data-processing-module/components/g-map-data-processing/g-map-data-processing.vue";
import DataProcessingCard
  from "@/modules/data-processing-module/components/data-processing-card/data-processing-card.vue";
import InfoModal from "@/modules/data-processing-module/components/info-modal/info-modal.vue";
import CheckMaterialsModal
  from "@/modules/data-processing-module/components/check-materials-modal/check-materials-modal.vue";
import {getVideoTimeFromLocal, getVideoTimeFromLocalToIsoString} from "@/utils/utils";
import ShowErrorsModal from "@/modules/data-processing-module/components/show-errors-modal/show-errors-modal.vue";

export default {
  name: "data-processing-page",
  components: {
    ShowErrorsModal,
    CheckMaterialsModal, InfoModal, GMapDataProcessing, SearchBoxProcessing, DataProcessingCard
  },
  data() {
    return {
      isLoading: false,
      timer: null,
      count: 0,
      refreshSeconds: 15,
      refreshSecondStepOne: 350,
      countSecondsStepOne: 0,
      progress: 0,
      progressStepOne: 0,
      refreshingData: false,
      refreshingStepOneData: false,

    }
  },
  mounted() {
    console.log('O Mounted')
    this.selectCalibration(null)
    this.setSelectedProcessingDevice(null)

    this.timer = setInterval(() => {
      if (!this.refreshingData) {
        this.count++
        this.progress = this.count / this.refreshSeconds * 100
        if (this.count === this.refreshSeconds) {
          this.count = 0
          this.progress = this.count / this.refreshSeconds * 100
          this.refreshData()
        }
      }
      if (!this.refreshingStepOneData) {
        this.countSecondsStepOne++
        this.progressStepOne = this.countSecondsStepOne / this.refreshSecondStepOne * 100
        if (this.countSecondsStepOne === this.refreshSecondStepOne) {
          this.countSecondsStepOne = 0
          this.progressStepOne = this.countSecondsStepOne / this.refreshSecondStepOne * 100
          this.refreshStepOneData()
        }
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    this.count = 0
  },
  methods: {
    ...mapActions({
      setSelectedProcessingProject: 'dataProcessingModule/setSelectedProcessingProject',
      selectCalibration: 'dataProcessingModule/selectCalibration',
      setSelectedProcessingDevice: 'dataProcessingModule/setSelectedProcessingDevice',
      createTasks: 'dataProcessingModule/createTasks',
      pushTasksToSqs: 'dataProcessingModule/pushTasksToSqs',
      runInitialValidation: 'dataProcessingModule/runInitialValidation',
      getInitialValidation: 'dataProcessingModule/getInitialValidation',
      checkVideoPathTasks: 'dataProcessingModule/checkVideoPathTasks',
      runFullValidation: 'dataProcessingModule/runFullValidation',
      runPedestrianProcessing: 'dataProcessingModule/runPedestrianProcessing',
      resetProcessingStep: 'dataProcessingModule/resetProcessingStep',
      setRefreshingDevices: 'dataProcessingModule/setRefreshingDevices',
      setVideoPathRefreshingDevices: 'dataProcessingModule/setVideoPathRefreshingDevices',
      updateProcessingPeriods: 'dataProcessingModule/updateProcessingPeriods',
    }),
    onShowErrors(errors) {
      console.log('On show errors', errors)
      this.$refs.errorsModal.show(true, errors)
    },
    async onRefreshClicked() {
      this.isLoading = true
      await this.setSelectedProcessingProject(this.selectedProcessingProject.project)
      this.isLoading = false
    },
    async onToggleSelectedProject(project) {
      console.log('Selected project: toggle', project)
      if (project === null) {
        await this.setSelectedProcessingProject(null)
      } else {
        this.isLoading = true
        await this.setSelectedProcessingProject(project)
        this.isLoading = false
      }
    },
    refreshData() {
      console.log('On refresh data')
      this.refreshingData = true
      let refreshDataDevices = this.getRefreshingDevices
      console.log('Refreshing 2-4 devices: ', refreshDataDevices)
      this.setRefreshingDevices(refreshDataDevices.deviceRefresh)

      setTimeout(() => {
        this.refreshingData = false
      }, 5000)

      if (refreshDataDevices.doRefresh) {
        console.log('Run Refresh', refreshDataDevices)
        this.getInitialValidation(this.selectedProcessingProject.project)
      }

    },
    refreshStepOneData() {
      console.log('On refresh step one data')
      this.refreshingStepOneData = true
      let refreshVehiclePathDevices = this.getRefreshVehiclePathDevices
      console.log('Refreshing path devices: ', refreshVehiclePathDevices)
      this.setVideoPathRefreshingDevices(refreshVehiclePathDevices.deviceRefresh)

      setTimeout(() => {
        this.refreshingStepOneData = false
      }, 5000)

      if (refreshVehiclePathDevices.doRefresh) {
        this.checkVideoPathTasks(this.selectedProcessingProject.project)
      }
    },
    async onAddTasksClick(deviceData) {

      this.isLoading = true

      let payload = {
        dataDeviceId: deviceData._id,
        saveTasks: false
      }

      let response = await this.createTasks(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        //this.show(false, false)
        console.log('Create tasks response: ', response)
        if (response.summaryCharts) {
          let chartsData = JSON.parse(JSON.stringify(response.summaryCharts))
          chartsData.forEach(data => {
            data.x = data.x.map(x => getVideoTimeFromLocalToIsoString(x))
          })

          let data = {
            _id: deviceData._id,
            siteName: deviceData.site.name,
            name: deviceData.name,
            chartsData: chartsData
          }
          this.$refs.checkMaterialsModal.show(true, data)
        }
      }

      this.isLoading = false
    },
    async onProceed(dt) {
      let data = JSON.parse(JSON.stringify(dt))
      this.$refs.checkMaterialsModal.show(false, null)
      console.log('On proceed data: ', data)


      this.isLoading = true

      let payload = {
        dataDeviceId: dt._id,
        saveTasks: true
      }

      let response = await this.createTasks(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Tasks successfully created', 'is-success')
        console.log('Create tasks response 1: ', response)
      }

      this.isLoading = false

    },
    async onUpdateProcessingPeriods(data){

      let payload = JSON.parse(JSON.stringify(data))

      console.log('OnUpdateProcessingPeriods payload: ', payload)

      this.$refs.infoModal.show(false)

      this.isLoading = true
      let response = await this.updateProcessingPeriods(payload)

      if (response instanceof Error) {
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else if(response === true) {
        await this.setSelectedProcessingProject(this.selectedProcessingProject.project)
        this.showToast('Processing periods successfully updated', 'is-success')
      }

      this.isLoading = false
    },
    async onRunTasksClick(dataDevice) {
      this.isLoading = true

      let payload = {
        data: {
          dataDeviceId: dataDevice._id,
          taskType: 'video_path_tracking',
          version: 1
        },
        selectedProject: this.selectedProcessingProject.project
      }

      let response = await this.pushTasksToSqs(payload)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        let message = 'Tasks successfully pushed to processing queue. Info: '
        if (response.pushToSqsMessage && response.pushToSqsMessage.message) {
          message += response.pushToSqsMessage.message
        } else {
          message += 'No Info'
        }
        this.showToast(message, 'is-success')
      }

      this.isLoading = false
    },
    onMapClicked() {
      console.log('On map clicked')
      if (this.$refs.searchBoxProcessing) {
        this.$refs.searchBoxProcessing.onClickedOutside()
      }
      console.log('Selected Processing Project: ', this.selectedProcessingProject)
    },
    onMapLoaded() {
      console.log('On map loaded')
    },
    closeProjectOverview() {
      this.setSelectedProcessingProject(null)
    },
    openCalibrationPage() {
      this.$router.push('/video-calibration')
    },
    onProcessingClick(data) {
      this.$refs.infoModal.show(true, data, 'Processing Period/s', 'periods')
    },
    async onRunInitialValidation(dataDevice) {
      console.log('Run initial validation: ', dataDevice)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let payload = {
        dataDeviceId: dataDevice._id,
        selectedProject: this.selectedProcessingProject.project
      }
      console.log('Payload: ', payload)

      let response = await this.runInitialValidation(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Initial validation successfully started', 'is-success')
      }

      this.isLoading = false
    },
    async onRunFullProcessing(dataDevice) {
      console.log('On run full processing: ', dataDevice)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let payload = {
        dataDeviceId: dataDevice._id,
        selectedProject: this.selectedProcessingProject.project
      }
      console.log('Payload: ', payload)

      let response = await this.runFullValidation(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Full Data Processing successfully started', 'is-success')
      }

      this.isLoading = false
    },
    async onRunPedestrianProcessing(dataDevice) {
      console.log('Run pedestrian processing: ', dataDevice)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let payload = {
        dataDeviceId: dataDevice._id,
        selectedProject: this.selectedProcessingProject.project
      }
      console.log('Payload: ', payload)

      let response = await this.runPedestrianProcessing(payload)

      if (response instanceof Error) {
        //this.showToast(response.message, 'is-danger')
        this.showSnackBar(`Error: ${response.message}`, 'is-danger')
        this.isLoading = false
      } else {
        this.showToast('Pedestrian Processing successfully started', 'is-success')
        this.isLoading = false
      }
    },
    onShowInitialResults(dataDevice) {
      console.log('On Show initial results:', dataDevice)
      this.setSelectedProcessingDevice(dataDevice)


      const params = {
        projectId: this.selectedProcessingProject.project._id,
        dataDeviceId: dataDevice._id,
        dataType: 'initial'
      }

      if (this.selectedDevice.initialValidationData && this.selectedDevice.initialValidationData.validationChart) {
        this.$router.push({name: 'auto-validation-review', params: params})
      }else{
        this.showToast('Initial charts not exists', 'is-danger')
      }
    },
    onShowFullResults(dataDevice) {
      console.log('On Show initial results:', dataDevice)
      this.setSelectedProcessingDevice(dataDevice)


      const params = {
        projectId: this.selectedProcessingProject.project._id,
        dataDeviceId: dataDevice._id,
      }

      //this.$router.push({name: 'qa', params: params})
      const routeData = this.$router.resolve({name: 'qa', params: params});
      window.open(routeData.href, '_blank');
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    showSnackBar(message, type) {
      this.$buefy.snackbar.open({
        message: message,
        type: type,
        position: 'is-top',
        actionText: 'Ok',
        indefinite: true,
        /*        onAction: () => {
                  this.$buefy.toast.open({
                    message: 'Action pressed',
                    queue: false
                  })
                }*/
      })
    },
    async onResetStep(data) {
      console.log('Reset step: ', data)
      this.isLoading = true
      //reset timer count
      this.count = 0
      let response = await this.resetProcessingStep(data)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
        this.isLoading = false
      } else {
        this.showToast('Reset Success', 'is-success')
        this.isLoading = false
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedProcessingProject: 'dataProcessingModule/getSelectedProcessingProject',
      selectedDevice: 'dataProcessingModule/getSelectedProcessingDevice'
    }),
    getRefreshingDevices() {
      let refreshData = {doRefresh: false, deviceRefresh: []}
      if (this.selectedProcessingProject && this.selectedProcessingProject.devices && this.selectedProcessingProject.devices.length > 0) {
        for (let i = 0; i < this.selectedProcessingProject.devices.length; i++) {
          let refresh = {id: this.selectedProcessingProject.devices[i]._id, refresh: false}
          let tasks

          if (this.selectedProcessingProject.devices[i].tasks) {
            tasks = this.selectedProcessingProject.devices[i].tasks
          }

          let initialTasks
          let initialCharts = null
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.tasks) {
            initialTasks = this.selectedProcessingProject.devices[i].initialValidationData.tasks
          }
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.validationChart) {
            initialCharts = this.selectedProcessingProject.devices[i].initialValidationData.validationChart
          }

          let pedTasks
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.pedTasks) {
            pedTasks = this.selectedProcessingProject.devices[i].initialValidationData.pedTasks
          }

          let fullTasks
          let fullCharts = null
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.fullTasks) {
            fullTasks = this.selectedProcessingProject.devices[i].initialValidationData.fullTasks
          }
          if (this.selectedProcessingProject.devices[i].initialValidationData && this.selectedProcessingProject.devices[i].initialValidationData.validationChart) {
            fullCharts = this.selectedProcessingProject.devices[i].initialValidationData.fullChart
          }
          //console.log('All Full Tasks', fullTasks)

          let allTasks = [initialTasks, tasks]
          console.log('Tasks', tasks)
          console.log('Initial tasks', initialTasks)

          if (tasks && tasks.status === 'COMPLETED') {
            if (initialTasks && initialTasks.status === 'COMPLETED' && initialCharts !== null && initialCharts.version === initialTasks.version) {
              //continue
            } else if (initialTasks && ((initialTasks.status !== 'COMPLETED' && initialTasks.status !== 'FAILED') || initialCharts === null || initialCharts.version !== initialTasks.version)) {
              refresh.refresh = true
              console.log('1', this.selectedProcessingProject.devices[i])
              refreshData.doRefresh = true
            }
          }

          //console.log('All ped Tasks', pedTasks)

          if (pedTasks && (pedTasks.status !== 'COMPLETED' && pedTasks.status !== 'FAILED')) {
            refresh.refresh = true
            refreshData.doRefresh = true
            console.log('2')
          }

          if (fullTasks && ((fullTasks.status !== 'COMPLETED' && fullTasks.status !== 'FAILED') || fullCharts === null || fullCharts.version !== fullTasks.version)) {
            refresh.refresh = true
            refreshData.doRefresh = true
            console.log('3')
          }

          refreshData.deviceRefresh.push(refresh)
        }
      }
      return refreshData
    },
    getRefreshVehiclePathDevices() {
      let refreshData = {doRefresh: false, deviceRefresh: []}
      if (this.selectedProcessingProject && this.selectedProcessingProject.devices && this.selectedProcessingProject.devices.length > 0) {
        for (let i = 0; i < this.selectedProcessingProject.devices.length; i++) {
          let refresh = {id: this.selectedProcessingProject.devices[i]._id, refresh: false}
          let tasks

          if (this.selectedProcessingProject.devices[i].tasks) {
            tasks = this.selectedProcessingProject.devices[i].tasks
          }
          if (tasks && tasks.status !== 'COMPLETED' && tasks.status !== 'FAILED' && tasks !== 'CREATED') {
            refresh.refresh = true
            console.log('1', this.selectedProcessingProject.devices[i])
            refreshData.doRefresh = true
          }
          refreshData.deviceRefresh.push(refresh)
        }
      }
      return refreshData
    }
  }
}
</script>

<style scoped>
.title-box {
  background-color: hsl(0deg, 0%, 100%);
  border-radius: 0;
  box-shadow: 0 0.125em 0.5em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: hsl(0deg, 0%, 29%);
  display: block;
  padding: 1.25rem;
}
</style>